import { render, staticRenderFns } from "./aquacultureCategory.vue?vue&type=template&id=b0bce02e&scoped=true"
import script from "./aquacultureCategory.vue?vue&type=script&lang=js"
export * from "./aquacultureCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bce02e",
  null
  
)

export default component.exports